module.exports = __webpack_public_path__ + "images/fa-cfa-instructor-365-careers.webp";